import React from "react";

// components
import JobCard from "../../../components/ui/cards/JobCard";
import { Pagination } from "antd";

// state
import { get_jobs } from "../../../services/api/jobs";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
// constants
import { FaSearch } from "react-icons/fa";
import SearchInput from "../../../components/elements/forms/SearchInput";
import { setSearch as setGlobalSearch } from "../../../store/slices/jobs";

const Jobs = () => {
  const dispatch = useAppDispatch();
  const {
    jobs,
    current_page,
    total,
    per_page,
    search: globalSearch,
  } = useAppSelector(({ jobs }) => jobs);
  const [search, setSearch] = React.useState<string>("");

  const onLoad = React.useCallback(() => {
    get_jobs(dispatch, 1, globalSearch);
  }, [dispatch, globalSearch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);
    dispatch(setGlobalSearch(value));
  };

  React.useEffect(() => {
    setSearch(globalSearch);
  }, [globalSearch]);

  const handlePageChange = (page: number) => {
    get_jobs(dispatch, page, globalSearch);
  };

  const search_icon = <FaSearch color="#243677" />;

  return (
    <div className="w-full md:px-5 md:py-4">
      <div className="my-2 w-full flex text-right justify-between items-center">
        <div className="text-left font-semibold text-gray-600">
          Total Jobs: {total}
        </div>
        <div className="w-4/12">
          <SearchInput
            name="Search"
            placeholder="Search..."
            value={search}
            onChange={onSearch}
            icon={search_icon}
          />
        </div>
      </div>
      <div className="space-y-4">
        {jobs.map((job) => (
          <JobCard key={job.slug} item={job} />
        ))}
      </div>
      <div className="mt-8 mb-4 flex justify-center">
        <Pagination
          current={Number(current_page)}
          total={total}
          pageSize={per_page}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default Jobs;
